import ENV from '../modules/env'
import { NewURL } from '../utils'

const platformRoute = [
  { id: ENV.TELEMEDICINE_PLATFORM_ID, route: '/telemedicina' },
  { id: ENV.CLINICS_PLATFORM_ID, route: '/clinica-einstein/agenda' },
  { id: ENV.CLINICAL_STAFF_PLATFORM_ID, route: '/corpo-clinico' },
  { id: ENV.CLINICAL_STAFF_PLATFORM_ID, route: '/oncologia' },
  { id: ENV.HMVSC_PLATFORM_ID, route: '/hmvsc' }
]

const defaultRoute = {
  id: ENV.TELEMEDICINE_PLATFORM_ID,
  route: '/telemedicina'
}

interface LoginSSO {
  patientEpisodeNumber?: string
  target?: string | null
}
type GetPlatformRoute = (id: number | null | string, loginSSO?: LoginSSO) => string

export const getPlatformRoute: GetPlatformRoute = (id, loginSSO) => {
  const filter = platformRoute.filter(element => element.id === id)

  const route = filter[0]?.route || defaultRoute.route

  if (loginSSO && id === ENV.CLINICAL_STAFF_PLATFORM_ID) {
    if (loginSSO.target) {
      const path = new NewURL(`${route}/inicio`)

      if (loginSSO.patientEpisodeNumber) {
        if (loginSSO.target === 'prescricao') {
          path.setQueryParams('medicalRecord', loginSSO.patientEpisodeNumber).setQueryParams('target', loginSSO.target)
        } else {
          path.setQueryParams('episodeNumber', loginSSO.patientEpisodeNumber).setQueryParams('target', loginSSO.target)
        }
      }

      return path.toString()
    }

    const defaultPathLoginSSO = new NewURL(`${route}/inicio`)

    if (loginSSO.patientEpisodeNumber) {
      defaultPathLoginSSO.setQueryParams('episodeNumber', loginSSO.patientEpisodeNumber)
    }

    return defaultPathLoginSSO.toString()
  }

  return route
}

export const getPlatformIdByRoute = (route: string) => {
  const id = platformRoute.filter(element => element.route.includes(route) || route.includes(element.route))[0]?.id
  if (!id) return
  return Number(id) || defaultRoute.id
}

export const getOfficeRoute = '/consultorio'
